import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import MoneyCurrency from "@icons/myicons/money-currency-banknotes-right-top.svg?react";
import { toCurrency } from "@helpers";
import { Banner } from "@rentablo/components";
import { useListAndSearchAllDiscounts } from "@rentablo/api/apiv1";

export const CashbackBonusBanner = () => {
  const { data: discountsList } = useListAndSearchAllDiscounts();
  const { t } = useTranslation();
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  if (
    !discountsList?.remainingInactiveDiscount &&
    !discountsList?.remainingActiveDiscount
  ) {
    return null;
  }

  const shouldDisplayActiveDiscountBanner = Boolean(
    discountsList?.remainingActiveDiscount
  );
  const shouldDisplayInactiveDiscountBanner = Boolean(
    discountsList?.remainingInactiveDiscount
  );

  return (
    <Box display="flex" flexDirection="column" gap={3} mt={isSm ? 4 : 0} mb={6}>
      {shouldDisplayActiveDiscountBanner && (
        <Banner
          flexDirection={isSm ? "column" : "row"}
          type="white"
          text={
            <Box display="flex" gap={2}>
              <MoneyCurrency width="20px" height="20px" />
              <Box display="flex" flexWrap="wrap">
                <Typography component="span" variant="body3">
                  {t(
                    "domains.cashback.dashboard.cashbackBonusBanner.amountText",
                    {
                      amount: toCurrency(
                        discountsList?.remainingActiveDiscount,
                        "EUR",
                        true,
                        { minimumFractionDigits: 2 }
                      ),
                    }
                  )}
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
      {shouldDisplayInactiveDiscountBanner && (
        <Banner
          flexDirection={isSm ? "column" : "row"}
          type="white"
          text={
            <Box display="flex" gap={2}>
              <MoneyCurrency width="20px" height="20px" />
              <Box display="flex" flexWrap="wrap">
                <Typography component="span" variant="body3">
                  {t(
                    "domains.cashback.dashboard.cashbackBonusBanner.amountText",
                    {
                      amount: toCurrency(
                        discountsList?.remainingInactiveDiscount,
                        "EUR",
                        true,
                        { minimumFractionDigits: 2 }
                      ),
                    }
                  )}
                </Typography>
                <Typography
                  component="span"
                  color="textSecondary"
                  variant="body3"
                >
                  &nbsp;
                  {t(
                    "domains.cashback.dashboard.cashbackBonusBanner.inactiveText"
                  )}
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
    </Box>
  );
};
